module.exports = __webpack_public_path__ + "img/starbucks-status-panel.d509dadb.png";